// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3ZDJn","vLegacy":"SelectSecondary_vLegacy__2ObDt","error":"SelectSecondary_error__ZUXuJ","disabled":"SelectSecondary_disabled__dfpGr"};